// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608190704/js/" + chunkId + "." + {"44":"b83bccc2","225":"d2fdaf51","481":"0d5d5693","486":"a5baa56c","770":"b3c44b59"}[chunkId] + ".0.4084827664338955.chunk.js";
};